import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "textarea"]

  connect() {
    // Listen for Bootstrap modal shown event
    this.element.addEventListener('shown.bs.modal', this.focusTextarea.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.modal', this.focusTextarea.bind(this))
  }

  focusTextarea() {
    if (this.hasTextareaTarget) {
      this.textareaTarget.focus()
    }
  }

  handleKeydown(event) {
    // Check for Cmd+Enter (Mac) or Ctrl+Enter (Windows/Linux)
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault();
      this.formTarget.requestSubmit();
    }
  }
}
